import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/bookmark': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M336 0c26.5 0 48 21.5 48 48v464l-192-112-192 112v-464c0-26.5 21.5-48 48-48h288zM336 428.4v-374.4c0-3.3-2.7-6-6-6h-276c-3.3 0-6 2.7-6 6v374.4l144-84z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/bookmark.js
// module id = 1693
// module chunks = 0